import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ActiveActionIcon extends BaseOption {
  static userInterfaceComponent = {
    label: "Active Action Icon",
    component: inspectorTools.ICON_PICKER,
  };

  static defaultValue = "bxs:up-arrow";
}

